








import { Component, Vue } from 'vue-property-decorator';
import Report from './Report.vue';

@Component({
  components: {
    Report,
  },
})
export default class AdvancedPaychecksSummaryReport extends Vue {}
